import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { SparkleIcon } from '../components/ui/Icons';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function StoriesPage() {
    const [stories, setStories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStories = async () => {
            try {
                const response = await axios.get(`${API}/stories`);
                setStories(response.data);
            } catch (error) {
                console.error('Failed to fetch stories:', error);
            } finally {
                setLoading(false);
            }
        };
        fetchStories();
    }, []);

    return (
        <div className="min-h-screen" data-testid="stories-page">
            {/* Header */}
            <header className="text-center py-12 md:py-16">
                <h1 className="text-4xl md:text-5xl italic mb-8">
                    Povídky
                </h1>
                <div className="w-full max-w-4xl mx-auto h-px bg-foreground/30" />
            </header>

            {/* Stories Grid */}
            <section className="max-w-6xl mx-auto px-6 pb-24">
                {loading ? (
                    <div className="text-center py-16">
                        <p className="text-xl italic text-muted-foreground">Načítání...</p>
                    </div>
                ) : stories.length === 0 ? (
                    <div className="text-center py-16">
                        <p className="text-xl italic text-muted-foreground">
                            Zatím zde nejsou žádné povídky.
                        </p>
                    </div>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-8 gap-y-16">
                        {stories.map((story, index) => (
                            <Link 
                                key={story.id}
                                to={`/povidka/${story.id}`}
                                className="block group"
                                data-testid={`story-card-${story.id}`}
                            >
                                {/* New story label - only for first */}
                                {story.is_new && index === 0 && (
                                    <div className="flex items-center gap-2 mb-3 h-8">
                                        <SparkleIcon className="w-4 h-6 text-foreground/60" />
                                        <span className="font-handwritten text-lg italic">nová povídka</span>
                                    </div>
                                )}
                                {/* Spacer for alignment when no label */}
                                {!(story.is_new && index === 0) && (
                                    <div className="h-8 mb-3" />
                                )}
                                
                                {/* Story title in uppercase */}
                                <h2 className="text-base md:text-lg uppercase tracking-widest font-medium mb-1">
                                    {story.title}
                                </h2>
                                
                                {/* Author name */}
                                <p className="text-sm italic text-muted-foreground mb-3">
                                    {story.author_name}
                                </p>
                                
                                {/* Story description/preview - fixed height for alignment */}
                                <p className="text-sm leading-relaxed text-foreground/80 mb-4 line-clamp-4 min-h-[5rem]">
                                    {story.preview_text}
                                </p>
                                
                                {/* Story illustration - square */}
                                {story.cover_image_url && (
                                    <div className="aspect-square overflow-hidden">
                                        <img 
                                            src={story.cover_image_url} 
                                            alt={story.title}
                                            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                                            loading="lazy"
                                        />
                                    </div>
                                )}
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </div>
    );
}
